import {
  CountryCode,
  CountrySubdivisions,
} from "pages/employer-of-record/onboarding/constants";
import {
  EmployeePayType,
  FormPayTypeValue,
} from "pages/employer-of-record/payments/constants";
import * as CA_BONUS_CONFIGS from "./BonusPay/countryConfigs/CA/constants";
import * as CA_COMMISSION_CONFIGS from "./Comission/countryConfigs/CA/constants";
import * as CO_BONUS_CONFIGS from "./BonusPay/countryConfigs/CO/constants";
import * as DEFAULT_BONUS_CONFIGS from "./BonusPay/countryConfigs/DEFAULT/constants";
import * as DEFAULT_COMMISSION_CONFIGS from "./Comission/countryConfigs/DEFAULT/constants";
import * as DEFAULT_OFFCYCLE_CONFIGS from "./OffCycle/countryConfigs/DEFAULT/constants";
import * as DEFAULT_RETROACTIVE_CONFIGS from "./Retroactive/countryConfigs/DEFAULT/constants";
import * as IE_BONUS_CONFIGS from "./BonusPay/countryConfigs/IE/constants";
import * as PH_BONUS_CONFIGS from "./BonusPay/countryConfigs/PH/constants";

import { CountryConfigKeyType, SubdivisionConfigKeyType } from "./types";

const defaultConfigs = {
  [EmployeePayType.BONUS]: DEFAULT_BONUS_CONFIGS,
  [EmployeePayType.COMISSION]: DEFAULT_COMMISSION_CONFIGS,
  [EmployeePayType.OFF_CYCLE]: DEFAULT_OFFCYCLE_CONFIGS,
  [EmployeePayType.RETROACTIVE]: DEFAULT_RETROACTIVE_CONFIGS,
};

const CONFIG_MAPS = {
  [CountryCode.AU]: defaultConfigs,
  [CountryCode.BE]: defaultConfigs,
  [CountryCode.BG]: defaultConfigs,
  [CountryCode.BR]: defaultConfigs,
  [CountryCode.CA]: {
    [EmployeePayType.BONUS]: CA_BONUS_CONFIGS,
    [EmployeePayType.COMISSION]: CA_COMMISSION_CONFIGS,
    [EmployeePayType.OFF_CYCLE]: DEFAULT_OFFCYCLE_CONFIGS,
    [EmployeePayType.RETROACTIVE]: DEFAULT_RETROACTIVE_CONFIGS,
  },
  [CountryCode.CL]: defaultConfigs,
  [CountryCode.CO]: {
    [EmployeePayType.BONUS]: CO_BONUS_CONFIGS,
    [EmployeePayType.COMISSION]: DEFAULT_COMMISSION_CONFIGS,
    [EmployeePayType.OFF_CYCLE]: DEFAULT_OFFCYCLE_CONFIGS,
    [EmployeePayType.RETROACTIVE]: DEFAULT_RETROACTIVE_CONFIGS,
  },
  [CountryCode.CR]: defaultConfigs,
  [CountryCode.CY]: defaultConfigs,
  [CountryCode.DE]: defaultConfigs,
  [CountryCode.DK]: defaultConfigs,
  [CountryCode.EE]: defaultConfigs,
  [CountryCode.ES]: defaultConfigs,
  [CountryCode.FI]: defaultConfigs,
  [CountryCode.FR]: defaultConfigs,
  [CountryCode.GB]: defaultConfigs,
  [CountryCode.GE]: defaultConfigs,
  [CountryCode.GR]: defaultConfigs,
  [CountryCode.HR]: defaultConfigs,
  [CountryCode.IE]: {
    [EmployeePayType.BONUS]: IE_BONUS_CONFIGS,
    [EmployeePayType.COMISSION]: DEFAULT_COMMISSION_CONFIGS,
    [EmployeePayType.OFF_CYCLE]: DEFAULT_OFFCYCLE_CONFIGS,
    [EmployeePayType.RETROACTIVE]: DEFAULT_RETROACTIVE_CONFIGS,
  },
  [CountryCode.IL]: defaultConfigs,
  [CountryCode.IN]: defaultConfigs,
  [CountryCode.IT]: defaultConfigs,
  [CountryCode.KE]: defaultConfigs,
  [CountryCode.LV]: defaultConfigs,
  [CountryCode.MX]: defaultConfigs,
  [CountryCode.MY]: defaultConfigs,
  [CountryCode.NG]: defaultConfigs,
  [CountryCode.NL]: defaultConfigs,
  [CountryCode.NO]: defaultConfigs,
  [CountryCode.NZ]: defaultConfigs,
  [CountryCode.PA]: defaultConfigs,
  [CountryCode.PE]: defaultConfigs,
  [CountryCode.PH]: {
    [EmployeePayType.BONUS]: PH_BONUS_CONFIGS,
    [EmployeePayType.COMISSION]: DEFAULT_COMMISSION_CONFIGS,
    [EmployeePayType.OFF_CYCLE]: DEFAULT_OFFCYCLE_CONFIGS,
    [EmployeePayType.RETROACTIVE]: DEFAULT_RETROACTIVE_CONFIGS,
  },
  [CountryCode.PK]: defaultConfigs,
  [CountryCode.PL]: defaultConfigs,
  [CountryCode.PT]: defaultConfigs,
  [CountryCode.RO]: defaultConfigs,
  [CountryCode.SE]: defaultConfigs,
  [CountryCode.SG]: defaultConfigs,
  [CountryCode.TR]: defaultConfigs,
  [CountryCode.UY]: defaultConfigs,
  [CountryCode.ZA]: defaultConfigs,
} as const;

const SUBDIVISION_CONFIG_MAP = {
  [CountryCode.US]: {
    [CountrySubdivisions.PR]: defaultConfigs,
  },
} as const;

const loadSubdivisionConfig = (
  type: FormPayTypeValue,
  country: keyof typeof SUBDIVISION_CONFIG_MAP,
  subdivision: SubdivisionConfigKeyType
) => {
  const configs =
    SUBDIVISION_CONFIG_MAP[country][subdivision][
      type as keyof typeof defaultConfigs
    ];
  return configs;
};

export const loadCountryConfigFiles = (
  type: FormPayTypeValue,
  country: CountryConfigKeyType,
  subdivision?: SubdivisionConfigKeyType
) => {
  if (subdivision) {
    return loadSubdivisionConfig(
      type,
      country as keyof typeof SUBDIVISION_CONFIG_MAP,
      subdivision
    );
  }

  const configs =
    CONFIG_MAPS[country as keyof typeof CONFIG_MAPS][
      type as keyof (typeof CONFIG_MAPS)[keyof typeof CONFIG_MAPS]
    ];
  return configs;
};
